<template>
  <tr
  v-if="vmode === 0"
  :class="{'selected': selected[item.tempID]}">

  <td class="sticky">
      <div class="c-flex align-center">
        <v-icon 
        class="drag-handle" color="">menu</v-icon>
        <v-icon 
        @click.stop="$emit('checkRow', item)"
        :color="selected[item.tempID] ? 'color1' : ''"> 
          {{ selected[item.tempID] ? 'check_box' : 'check_box_outline_blank' }}
        </v-icon>
        <img class="c-align-self-start" src="@/assets/img/illustrations/sugar-and-cinnamon.png" alt="cardboard box" width="46px">
        <span class="ml-3" v-html="highlightedName">
        </span>
      </div>
    </td>

    <td>
      <c-ms-ii
      :metric_definition="item.definition" 
      :realValue.sync="item.quantity"
      :prefferedSid="prefferedSid"
      class="borderless"
      ></c-ms-ii>
    </td>

    <td>
      <c-input :value.sync="item.percent" class="borderless">
      </c-input>
    </td>

  </tr>
  <!-- MOBILE -->
    <v-layout 
    v-else-if="vmode === 1"
    class="mrow">
      <v-flex xs8 class="align-center c-flex-r flex-cell">
        <v-icon class="drag-handle" color="">menu</v-icon>
        <v-btn
        icon flat
        @click.stop="$emit('checkRow', item)"
        class="ma-0"
        :color="selected[item.tempID] ? 'color1' : ''">
          <v-icon> 
            {{ selected[item.tempID] ? 'check_box' : 'check_box_outline_blank' }}
          </v-icon>
        </v-btn>
        <img class="pl-1 c-align-self-start" src="@/assets/img/illustrations/sugar-and-cinnamon.png" alt="cardboard box" height="32px">
        <div>
          {{ item.name }}
        </div>
      </v-flex>
      <v-flex xs4 class="flex-cell">
        <c-ms-ii
        :metric_definition="item.definition" 
        :realValue.sync="item.quantity"
        :prefferedSid="prefferedSid"
        class="borderless"
        ></c-ms-ii>
      </v-flex>
      <v-flex xs4 class="flex-cell">
        <c-input :value.sync="item.percent" class="borderless">
        </c-input>
      </v-flex>
    </v-layout>

    <!-- DIALOG -->
    <div v-else-if="vmode === 2">
      <div class="text-xs-center">
        <img src="@/assets/img/illustrations/sugar-and-cinnamon.png" alt="cardboard box" height="132px">
      </div>
      <div class="font-weight-medium text-xs-center">
        {{ (item || {}).name }}
      </div>
      <div class="caption">
        Quantity
      </div>
      <c-ms-ii
      :metric_definition="item.definition" 
      :realValue.sync="item.quantity"
      :prefferedSid="prefferedSid"
      class="crx-box-input"
      ></c-ms-ii>
      <div class="caption">
        Percent
      </div>
      <c-input :value.sync="item.percent" class="crx-box-input">
      </c-input>
    </div>

</template>

<script>
export default {
  props: ['item', 'vmode', 'selected', 'searchText', 'selectedCount', 'prefferedSid'],
  data () {
    return {
      // 8
    }
  },
  computed: {
    highlightedName () {
      if (!this.searchText) {
        return this.item.definition.name
      }
      var replacedStr = (this.searchText || '').trim().split(/\s+/).map(x => x.replace(/[-[\]{}()*+!<=:?.\\^$|#\s,]/g, '\\$&')).join('|')
      replacedStr = this.item.definition.name.replace(new RegExp(replacedStr, 'gi'), '<span class="font-weight-regular">$&</span>')
      return '<span class="font-weight-bold">' + replacedStr + '</span>'
    }
  }
}
</script>

<style scoped lang="scss">
.drag-handle {
  cursor: move;
}
.mrow {
  cursor: pointer;
  position: relative;
  min-height: 60px;
  border-bottom: 1px solid var(--v-hline-base);

  &:hover {
    background: #fafbfc;
  }
}
.flex-cell {
  padding: 5px;
  border-right: 1px solid var(--v-hline-base);
  display:flex;
  align-items: center;
  text-overflow: ellipsis;
  overflow: hidden;
}
.triangle {
  width: 12px;
  height: 12px;
  background: var(--v-text-base);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  margin-left: -6px;
  margin-right: 2px;
  margin-top: 10px;
}
</style>
